import { TriggerManager } from '../trigger-manager/trigger-manager';
import log from 'loglevel';

/**
 * Adds a new custom trigger at runtime that then can be called and executed within the command queue.
 * Only allows synchronous functions that do not return a value.
 * @param customTriggerName the name of the new trigger
 * @param customTriggerFn the function executed when the trigger gets called
 */
export default function(customTriggerName: string, customTriggerFn: (...args: any[]) => void) {
  if (typeof customTriggerName === 'string' && typeof customTriggerFn === 'function') {
    TriggerManager.registerTrigger(customTriggerName, customTriggerFn);
  } else {
    log.error(`The provided arguments to customTrigger are invalid. Please provide a name and a function.`);
  }
}